<template>
  <v-menu
    ref="menu"
    :close-on-content-click="true"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :value="currentDate ? timeToDate(currentDate) : null"
      :label="label"
      background-color="white"
      :class="label ? '' : 'small'"
      :prepend-inner-icon="innerIcon"
      hide-details
      readonly
    />
    <v-date-picker
      :value="currentDate"
      @change="updateField($event)"
      no-title
      scrollable
      first-day-of-week="1"
    />
  </v-menu>
</template>

<script>
import date from "../../mixins/date.js";

export default {
  name: "dateField",
  mixins: [date],
  props: {
    currentDate: {
      type: String,
      required: true,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    storeName: {
      type: String,
      required: false,
      default: "",
    },
    objectName: {
      type: String,
      required: false,
      default: "",
    },
    fieldName: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
    innerIcon: {
      type: String,
      required: false,
      default: "event",
    },
  },
  methods: {
    updateField(event) {
      if (this.storeName && this.objectName && this.fieldName) {
        this.updateFieldInStore(
          this.storeName,
          this.objectName,
          this.fieldName,
          event
        );
      }
      this.$emit("input", event);
    },
  },
};
</script>

<style lang="stylus">
.small > div > div.v-input__slot.white {
  min-height: 20px !important;
  margin-top: 0px !important;
}

.small > div > div > div > input[type='text'] {
  margin-top: 0px !important;
}

.small > div > div.v-text-field__details {
  display: none;
}
</style>
